import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import Swal from "sweetalert2"; // Import SweetAlert2 for notifications
import EditListingNavbar from "./SellerComp/EditListingNavbar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import { Edit } from "react-feather";
import AddMoreCategory from "./SellerComp/AddMoreCategory";
const EditListing = () => {
  const { listing_id } = useParams();
  const navigate = useNavigate();

  // console.log("Listing ID from URL:", listing_id);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    listingCondition: "",
    listingStandard: "",
    listingCategory: "",
    listingBrand: "",
    listingType: "",
    price: "",
    mrp: "",
    currency: "INR",
    quantity: "",
    unitquantity: "",
    upc: "",
    mpn: "",
    hsn: "",
    modal: "",
    manufacturer: "",
    state: "",
    unlimitedQuantity: false,
    listingCategoryTwo: "",
    gst: "",
    availableat: "",
    weight: "",
    product_type: "",
  });

  const [brands, setBrands] = useState([]);
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllBrands`);
        if (response.status === 200) {
          setBrands(response.data.data); // Assuming response contains a `data` array
        }
      } catch (error) {
        // console.error("Error fetching brands:", error);
      }
    };

    fetchBrands();
  }, []);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch listing details by listing_id
    const fetchListingDetails = async () => {
      try {
        // Data being sent to the backend
        // console.log("API Request URL:", `${baseurl}seller/listing/${listing_id}`);

        const response = await axios.get(
          `${baseurl}seller/listing/${listing_id}`
        );
        console.log("Full API Response:", response);

        const data = response.data.listingData;
        // console.log("Extracted Listing Data:", data);

        if (data) {
          const formDataToSet = {
            title: data.title || "",
            description: data.description || "",
            listingCondition: data.condition || "",
            listingStandard: data.listingstandard || "",
            listingCategory: data.category || "",
            listingBrand: data.brand || "",
            listingType: data.type || "",
            price: data.price || "",
            mrp: data.mrp || "",
            currency: data.currency || "INR",
            quantity: data.quantity || "",
            unitquantity: data.unitquantity || "",
            upc: data.upc || "",
            mpn: data.mpn || "",
            hsn: data.hsn || "",
            modal: data.modal || "",
            manufacturer: data.manufacturer || "",
            state: data.state || "",
            unlimitedQuantity: data.unlimitedquantity || false,
            gst: data.gst || "",
            availableat: data.availableat || "",
            weight: data.weight || "",
            product_type: data.product_type || "",
          };

          // console.log("Data Sent to Backend:", formDataToSet);
          setFormData(formDataToSet);
        }
      } catch (error) {
        console.error("Error fetching listing details:", error);
      } finally {
        setLoading(false); // Set loading to false once data is fetched
      }
    };

    fetchListingDetails();
  }, [listing_id]);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseurl}getMenusByCategory`);

        console.log("data getMenusByCategory", response);
        if (response.data) {
          const categoryOptions = response.data.map((category) => ({
            value: category.id.toString(), // Convert to string for comparison
            label: category.path, // Display path instead of ID
          }));
          setCategories(categoryOptions);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Ensure formData.listingCategory is a string before splitting
  const categoryIds =
    typeof formData.listingCategory === "string"
      ? formData.listingCategory.includes(",")
        ? formData.listingCategory.split(",").map((id) => id.trim()) // If comma-separated, split into array
        : [formData.listingCategory.trim()] // Otherwise, keep as a single-item array
      : [];

  // Ensure categories is an array before filtering
  const matchedCategories = Array.isArray(categories)
    ? categories.filter((category) => categoryIds.includes(category.value))
    : [];

  // Display logic: Show comma-separated values only if there are multiple
  const categoryDisplay =
    matchedCategories.length > 1
      ? matchedCategories.map((cat) => cat.label).join(", ")
      : matchedCategories[0]?.label || ""; // Show single value if only one exists

  // console.log("Matched Categories:", categoryDisplay);

  const [menus, setMenus] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subSubCategories, setSubSubCategories] = useState([]);
  const [subSubSubCategories, setSubSubSubCategories] = useState([]);
  const [finalCategories, setFinalCategories] = useState([]);
  const [sixCategories, setSixCategories] = useState([]);
  const [seventhCategories, setSeventhCategories] = useState([]);
  const [eightCategories, setEightCategories] = useState([]);
  const [nineCategories, setNineCategories] = useState([]);

  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubSubCategory, setSelectedSubSubCategory] = useState("");
  const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] =
    useState("");
  const [selectedFinalCategory, setSelectedFinalCategory] = useState("");
  const [selectedSixCategory, setSelectedSixCategory] = useState("");
  const [selectedSeventhCategory, setSelectedSeventhCategory] = useState("");
  const [selectedEightCategory, setSelectedEightCategory] = useState("");
  const [selectedNineCategory, setSelectedNineCategory] = useState("");

  // const [categories, setCategories] = useState([]);

  // Fetch Menus
  useEffect(() => {
    axios
      .get(`${baseurl}getMenus`)
      .then((response) => {
        setMenus(response.data);
        setMainCategories(
          response.data.filter((menu) => menu.parent_id === null)
        );
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);

  // Handle dropdown changes
  const handleMainCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedMainCategory(selectedId);
    setSubCategories(menus.filter((menu) => menu.parent_id === selectedId));

    // Reset all lower-level categories
    setSelectedSubCategory("");
    setSubSubCategories([]);
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubCategory(selectedId);
    setSubSubCategories(menus.filter((menu) => menu.parent_id === selectedId));

    // Reset lower categories
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSubSubCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);

    handleCategoryChange({ value: selectedCategoryId });

    const selectedId = parseInt(e.target.value);
    setSelectedSubSubCategory(selectedId);
    setSubSubSubCategories(
      menus.filter((menu) => menu.parent_id === selectedId)
    );

    // Reset lower categories
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSubSubSubCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);

    handleCategoryChange({ value: selectedCategoryId });

    const selectedId = parseInt(e.target.value);
    setSelectedSubSubSubCategory(selectedId);
    setFinalCategories(menus.filter((menu) => menu.parent_id === selectedId));

    // Reset lower categories
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleFinalCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);

    handleCategoryChange({ value: selectedCategoryId });

    const selectedId = parseInt(e.target.value);
    setSelectedFinalCategory(selectedId);
    setSixCategories(menus.filter((menu) => menu.parent_id === selectedId));

    // Reset 6th, 7th, 8th, and 9th level categories
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSixCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);

    handleCategoryChange({ value: selectedCategoryId });

    const selectedId = parseInt(e.target.value);
    setSelectedSixCategory(selectedId);
    setSeventhCategories(menus.filter((menu) => menu.parent_id === selectedId));

    // Reset 7th, 8th, and 9th level categories
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSeventhCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);

    handleCategoryChange({ value: selectedCategoryId });

    const selectedId = parseInt(e.target.value);
    setSelectedSeventhCategory(selectedId);
    setEightCategories(menus.filter((menu) => menu.parent_id === selectedId));

    // Reset 8th and 9th level categories
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleEightCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);

    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedEightCategory(selectedId);
    setNineCategories(menus.filter((menu) => menu.parent_id === selectedId));

    // Reset 9th level category
    setSelectedNineCategory("");
  };

  const handleNineCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);

    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedNineCategory(selectedId);
  };

  const handleCategoryChange = (selectedOption) => {
    setFormData((prevData) => {
      const updatedCategory = selectedOption ? selectedOption.value : "";

      console.log("Updated Category:", updatedCategory); // Logging outside setState

      return {
        ...prevData,
        listingCategory: updatedCategory,
      };
    });
  };

  const [showCategory, setShowCategory] = useState(false);

  // Function to update AddMoreCategory data
  const handleCategoryChangetwo = (categoriesData) => {
    setFormData({ ...formData, listingCategoryTwo: categoriesData });
  };

  const handleRemoveCategory = () => {
    setFormData((prevData) => ({
      ...prevData,
      listingCategoryTwo: null,
    }));
    setShowCategory(false);
  };

  const [isEditing, setIsEditing] = useState(false);

  // Toggle Edit Mode
  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  // Fetch all countries on mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllCountries`);
        setCountries(response.data.countries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  // Fetch states when the country changes
  useEffect(() => {
    if (formData.manufacturer) {
      const fetchStates = async () => {
        try {
          const response = await axios.get(
            `${baseurl}getAllStatesByCountryId/${formData.manufacturer}`
          );
          setStates(response.data.states);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };
      fetchStates();
    } else {
      setStates([]); // Reset states if no country is selected
    }
  }, [formData.manufacturer]);

  const handleDescriptionChange = (content) => {
    setFormData({ ...formData, description: content });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
      ...(name === "unlimitedQuantity" && checked ? { quantity: "" } : {}),
    }));
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.title.trim()) formErrors.title = "Title is required.";
    // if (!formData.description.trim())
    //   formErrors.description = "Description is required.";
    if (!formData.listingCondition)
      formErrors.listingCondition = "Listing condition is required.";
    // if (!formData.listingCategory)
    //   formErrors.listingCategory = "Listing category is required.";
    if (!formData.listingType)
      formErrors.listingType = "Listing type is required.";
    if (!formData.price) formErrors.price = "Price is required.";
    if (!formData.unlimitedQuantity && !formData.quantity)
      formErrors.quantity = "Quantity is required.";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // console.log("Form data before validation:", formData);

    if (validateForm()) {
      // Prepare the data for submission
      const sellerId = localStorage.getItem("seller_id");
      const requestData = {
        seller_id: sellerId,
        title: formData.title,
        description: formData.description,
        listingCondition: formData.listingCondition,
        listingStandard: formData.listingStandard,
        listingCategory: formData.listingCategory,
        listingBrand: formData.listingBrand,
        listingType: formData.listingType,
        price: formData.price,
        mrp: formData.mrp || null,
        currency: formData.currency,
        quantity: formData.quantity,
        unlimitedQuantity: formData.unlimitedQuantity,
        listing_id: listing_id,
        unitquantity: formData.unitquantity,
        upc: formData.upc,
        mpn: formData.mpn,
        hsn: formData.hsn,
        modal: formData.modal,
        manufacturer: formData.manufacturer,
        state: formData.state,
        listingCategoryTwo: formData.listingCategoryTwo,
        gst: formData.gst,
        availableat: formData.availableat,
        weight: formData.weight,
        product_type: formData.product_type,
      };

      // Log the data to see what's being sent
      console.log("Form data being sent:", requestData);

      try {
        setLoading(true); // Start loading

        const response = await axios.put(
          `${baseurl}update_listing`,
          requestData,
          {
            headers: {
              "Content-Type": "application/json", // Use JSON content type
            },
          }
        );

        // console.log("Form submitted successfully:", response.data);

        // Show SweetAlert2 on success
        Swal.fire({
          icon: "success",
          title: "Listing Updated!",
          text: "Your listing has been updated successfully.",
        });

        // Navigate or redirect as needed after successful update
        const { listing_unique_id } = response.data.data;
        if (listing_unique_id) {
          navigate(`/seller/listing/${listing_unique_id}`);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setLoading(false); // Stop loading
      }

      setErrors({});
    } else {
      console.log("Form validation failed", errors); // Log validation errors if any
    }
  };

  if (loading) {
    // Show the loader while data is being fetched
    return (
      <div>
        <SellerNavbar />
        <div className="row my-3 g-2 justify-content-center">
          <div className="col-md-2">
            <SellerSidebar />
          </div>
          <div className="col-md-10">
            <div className="d-flex justify-content-center align-items-center vh-100">
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <EditListingNavbar />

                <div className="reviewcls text-start">
                  <h4 className="selh1">
                    Update Listing :{" "}
                    <strong className="">{formData.title}</strong>
                  </h4>
                  <hr />

                  {/* Show loader while `loading` is true */}
                  {loading && (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                      <div className="spinner-border text-danger" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}

                  <form
                    className="contact-form text-start"
                    onSubmit={handleSubmit}
                  >
                    <div className="row g-2">
                      <div className="col-md-12">
                        <label htmlFor="title" className="form-label">
                          Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="title"
                          name="title"
                          className="form-control"
                          placeholder="Enter your listing title"
                          value={formData.title}
                          onChange={handleInputChange}
                          required
                        />
                        {errors.title && (
                          <small className="text-danger">{errors.title}</small>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="listingCondition"
                          className="form-label"
                        >
                          Listing Condition
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          id="listingCondition"
                          name="listingCondition"
                          className="form-control"
                          value={formData.listingCondition}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select a condition</option>
                          <option value="used">Used</option>
                          <option value="new">New</option>
                          <option value="refurbished">Refurbished</option>
                          <option value="forParts">
                            For Parts/Not Working
                          </option>
                          <option value="notSpecified">Not Specified</option>
                        </select>
                        {errors.listingCondition && (
                          <small className="text-danger">
                            {errors.listingCondition}
                          </small>
                        )}
                      </div>

                      

                      <div className="col-md-12">
                        <label htmlFor="listingCategory" className="form-label">
                          Listing Category<span className="text-danger">*</span>
                        </label>

                        <div>
                          {matchedCategories.map((category, index) => (
                            <input
                              key={index}
                              type="text"
                              className="form-control"
                              value={category.label} // Display category path
                              disabled
                            />
                          ))}
                        </div>

                        <div className="text-end mt-2">
                          <span
                            className="btn btn-primary btn-sm me-2"
                            onClick={toggleEdit}
                          >
                            <Edit size={15} />{" "}
                            {isEditing ? "Cancel Edit" : "Update Main Category"}
                          </span>
                        </div>
                      </div>

                      {/* Show category selection only if isEditing is true */}
                      {isEditing && (
                        <div className="row g-2 bg-white pb-3">
                          {/* Main Category */}
                          <div className="col-md-4">
                            <label className="form-label">
                              Item Category
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              value={selectedMainCategory}
                              onChange={handleMainCategoryChange}
                              required
                            >
                              <option value="">Select Main Category</option>
                              {mainCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>
                                  {menu.title}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Other dropdowns (Sub Categories) */}
                          {subCategories.length > 0 && (
                            <div className="col-md-4">
                              <label className="form-label">
                                Sub Category
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-select"
                                value={selectedSubCategory}
                                onChange={handleSubCategoryChange}
                                required
                              >
                                <option value="">Select Sub Category</option>
                                {subCategories.map((menu) => (
                                  <option key={menu.id} value={menu.id}>
                                    {menu.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* Sub-Sub Category */}
                          {subSubCategories.length > 0 && (
                            <div className="col-md-4">
                              <label className="form-label">
                                Make/Brand<span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-select"
                                value={selectedSubSubCategory}
                                onChange={handleSubSubCategoryChange}
                                required
                              >
                                <option value="">
                                  Select Sub-Sub Category
                                </option>
                                {subSubCategories.map((menu) => (
                                  <option key={menu.id} value={menu.id}>
                                    {menu.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* Sub-Sub-Sub Category */}
                          {subSubSubCategories.length > 0 && (
                            <div className="col-md-4">
                              <label className="form-label">
                                Instrument Type
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-select"
                                value={selectedSubSubSubCategory}
                                onChange={handleSubSubSubCategoryChange}
                                required
                              >
                                <option value="">Select Instrument Type</option>
                                {subSubSubCategories.map((menu) => (
                                  <option key={menu.id} value={menu.id}>
                                    {menu.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {finalCategories.length > 0 && (
                            <div className="col-md-4">
                              <label className="form-label">
                                Modal Number
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-select"
                                id="listingCategory"
                                name="listingCategory"
                                value={selectedFinalCategory}
                                onChange={handleFinalCategoryChange}
                                required
                              >
                                <option value="">Select Final Category</option>
                                {finalCategories.map((menu) => (
                                  <option key={menu.id} value={menu.id}>
                                    {menu.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* 6th Level Category */}
                          {sixCategories.length > 0 && (
                            <div className="col-md-4">
                              <label className="form-label">
                                6th Level Category
                              </label>
                              <select
                                className="form-select"
                                value={selectedSixCategory}
                                onChange={handleSixCategoryChange}
                              >
                                <option value="">
                                  Select 6th Level Category
                                </option>
                                {sixCategories.map((menu) => (
                                  <option key={menu.id} value={menu.id}>
                                    {menu.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* 7th Level Category */}
                          {seventhCategories.length > 0 && (
                            <div className="col-md-4">
                              <label className="form-label">
                                7th Level Category
                              </label>
                              <select
                                className="form-select"
                                value={selectedSeventhCategory}
                                onChange={handleSeventhCategoryChange}
                              >
                                <option value="">
                                  Select 7th Level Category
                                </option>
                                {seventhCategories.map((menu) => (
                                  <option key={menu.id} value={menu.id}>
                                    {menu.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* 8th Level Category */}
                          {eightCategories.length > 0 && (
                            <div className="col-md-4">
                              <label className="form-label">
                                8th Level Category
                              </label>
                              <select
                                className="form-select"
                                value={selectedEightCategory}
                                onChange={handleEightCategoryChange}
                              >
                                <option value="">
                                  Select 8th Level Category
                                </option>
                                {eightCategories.map((menu) => (
                                  <option key={menu.id} value={menu.id}>
                                    {menu.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* 9th Level Category */}

                          {nineCategories.length > 0 && (
                            <div className="col-md-4">
                              <label className="form-label">
                                9th Level Category
                              </label>
                              <select
                                className="form-select"
                                value={selectedNineCategory}
                                onChange={handleNineCategoryChange}
                              >
                                <option value="">
                                  Select 9th Level Category
                                </option>
                                {nineCategories.map((menu) => (
                                  <option key={menu.id} value={menu.id}>
                                    {menu.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>
                      )}

                      {/* <div className="text-end">
      {!showCategory && (
        <button onClick={() => setShowCategory(true)} className="btn btn-primary btn-sm me-2"><Edit size={15} />{" "}Update 2nd Category</button>
      )}

      {showCategory && (
        <div className="text-start">
          <AddMoreCategory onCategoryChange={handleCategoryChangetwo} />
          <button onClick={handleRemoveCategory} className="btn btn-primary btn-sm me-2">Remove Category</button>
        </div>
      )}
    </div> */}

                      <div className="col-md-6">
                        <label htmlFor="mpn" className="form-label">
                          MPN
                        </label>
                        <input
                          type="text"
                          id="mpn"
                          name="mpn"
                          className="form-control"
                          placeholder="Enter MPN"
                          value={formData.mpn}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="hsn" className="form-label">
                          HSN
                        </label>
                        <input
                          type="text"
                          id="hsn"
                          name="hsn"
                          className="form-control"
                          placeholder="Enter HSN"
                          value={formData.hsn}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* Country Dropdown */}
                      <div className="col-md-6">
                        <label htmlFor="manufacturer" className="form-label">
                          Country/Region of Manufacturing
                        </label>
                        <select
                          id="manufacturer"
                          name="manufacturer"
                          className="form-control"
                          value={formData.manufacturer}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Country/Region</option>
                          {countries.map((country) => (
                            <option key={country.id} value={country.id}>
                              {country.country_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="availableat" className="form-label">
                          Item Available At
                        </label>
                        <input
                          type="text"
                          id="availableat"
                          name="availableat"
                          className="form-control"
                          placeholder="Enter Here"
                          value={formData.availableat}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* State Dropdown */}
                      {/* <div className="col-md-4">
                        <label htmlFor="state" className="form-label">
                          State
                        </label>
                        <select
                          id="state"
                          name="state"
                          className="form-control"
                          value={formData.state}
                          onChange={handleInputChange}
                        >
                          <option value="">Select State</option>
                          {states.map((state) => (
                            <option key={state.id} value={state.id}>
                              {state.state_name}
                            </option>
                          ))}
                        </select>
                      </div> */}

                      <div className="col-md-12">
                        <label className="form-label">
                          Listing Type<span className="text-danger">*</span>
                        </label>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="listingType"
                            id="quoteRequest"
                            value="quoteRequest"
                            onChange={handleInputChange}
                            checked={formData.listingType === "quoteRequest"}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="quoteRequest"
                          >
                            <strong>Request a Quote</strong>
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="listingType"
                            id="directSell"
                            value="directSell"
                            onChange={handleInputChange}
                            checked={formData.listingType === "directSell"}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="directSell"
                          >
                            <strong>Sell Directly</strong>
                          </label>
                        </div>
                        {errors.listingType && (
                          <small className="text-danger">
                            {errors.listingType}
                          </small>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="product_type" className="form-label">
                          Item / Product Type
                        </label>
                        <select
                          id="product_type"
                          name="product_type"
                          className="form-control"
                          value={formData.product_type}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Item Type</option>
                          <option value="Deliverable Product">
                            Deliverable Product
                          </option>
                          <option value="Digital Product">
                            Digital Product
                          </option>
                          <option value="Digital Service">
                            Digital Service
                          </option>
                          <option value="On site service">
                            On site service
                          </option>
                        </select>
                        <small>
                          <i>(This Indicate the type of Product / Item.)</i>
                        </small>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="weight" className="form-label">
                          Item Weight (In Grams)
                        </label>
                        <input
                          type="text"
                          id="weight"
                          name="weight"
                          className="form-control"
                          placeholder="Enter Weight in Grams"
                          value={formData.weight}
                          onChange={handleInputChange}
                        />
                        <small>
                          <i>(Leave Blank Or 0 [Zero] for Digital Items)</i>
                        </small>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="price" className="form-label">
                          Price<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="price"
                          name="price"
                          className="form-control"
                          placeholder="Enter your listing price"
                          value={formData.price}
                          onChange={handleInputChange}
                          required
                        />
                        {errors.price && (
                          <small className="text-danger">{errors.price}</small>
                        )}
                      </div>


                      <div className="col-md-2">
                        <label htmlFor="price" className="form-label">
                          MRP 
                        </label>
                        <div className="input-group">
                          <input
                            type="number"
                            id="mrp"
                            name="mrp"
                            className="form-control"
                            placeholder="Enter mrp"
                            value={formData.mrp}
                            onChange={handleInputChange}
                             
                          />
                           
                        </div>
                        
                      </div>
                      

                      <div className="col-md-6">
                        <label htmlFor="quantity" className="form-label">
                          Stock Quantity Available
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="quantity"
                          name="quantity"
                          className="form-control"
                          placeholder="Enter quantity"
                          value={formData.quantity}
                          onChange={handleInputChange}
                          disabled={formData.unlimitedQuantity}
                        />
                        {errors.quantity && (
                          <small className="text-danger">
                            {errors.quantity}
                          </small>
                        )}

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="unlimitedQuantity"
                            name="unlimitedQuantity"
                            checked={formData.unlimitedQuantity}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="unlimitedQuantity"
                          >
                            Unlimited Quantity
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="unitquantity" className="form-label">
                          Unit Quantity
                        </label>
                        <input
                          type="text"
                          id="unitquantity"
                          name="unitquantity"
                          className="form-control"
                          placeholder="Enter Unit Quantity"
                          value={formData.unitquantity || "1"}
                          onChange={handleInputChange}
                        />
                      </div>


                      <div className="col-md-6">
                        <label htmlFor="listingStandard" className="form-label">
                          Listing Standard<span className="text-danger">*</span>
                        </label>
                        <select
                          id="listingStandard"
                          name="listingStandard"
                          className="form-control"
                          value={formData.listingStandard}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select a Standard</option>
                          <option value="Piece (pc)">Piece (pc)</option>
                          <option value="Set (set) of">Set (set) of</option>
                          <option value="Pack (pack) of">Pack (pack) of</option>
                          <option value="Box (box) of">Box (box) of</option>
                          <option value="Gram (g)">Gram (g)</option>
                          <option value="Kilogram (kg)">Kilogram (kg)</option>
                          <option value="Milligram (mg)">Milligram (mg)</option>
                          <option value="Ton (t)">Ton (t)</option>
                          <option value="Millimeter (mm)">
                            Millimeter (mm)
                          </option>
                          <option value="Centimeter (cm)">
                            Centimeter (cm)
                          </option>
                          <option value="Meter (m)">Meter (m)</option>
                          <option value="Inche (in)">Inche (in)</option>
                          <option value="Foot (ft)">Foot (ft)</option>
                          <option value="Milliliter (ml)">
                            Milliliter (ml)
                          </option>
                          <option value="Liter (l)">Liter (l)</option>
                          <option value="Cubic Centimeter (cc)">
                            Cubic Centimeter (cc)
                          </option>
                          <option value="Cubic Meter (m3)">
                            Cubic Meter (m3)
                          </option>
                        </select>
                        {errors.listingCondition && (
                          <small className="text-danger">
                            {errors.listingCondition}
                          </small>
                        )}
                      </div>
                      

                      <div className="col-md-2">
                        <label htmlFor="gst" className="form-label">
                          GST
                        </label>
                        <select
                          id="gst"
                          name="gst"
                          className="form-control"
                          value={formData.gst || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select GST</option>
                          <option value="5">5%</option>
                          <option value="12">12%</option>
                          <option value="18">18%</option>
                          <option value="28">28%</option>
                        </select>
                      </div>

                      <div className="col-md-12">
                        <label htmlFor="description" className="form-label">
                          Description
                        </label>
                        <ReactQuill
                          value={formData.description}
                          onChange={handleDescriptionChange}
                          modules={{
                            toolbar: [
                              ["bold", "italic", "underline", "strike"], // Basic text styles
                              [{ align: [] }], // Text alignment (left, center, right)
                              [{ list: "ordered" }, { list: "bullet" }], // Lists (ordered, bullet)
                              ["link"], // Hyperlink insertion
                              [
                                { header: "1" },
                                { header: "2" },
                                { font: [] }, // Font options
                              ],
                              [{ color: [] }, { background: [] }], // Text color and background color
                              ["blockquote"], // Blockquote for quoted text
                              ["code-block"], // Code block option
                              ["undo", "redo"], // Undo and redo actions
                            ],
                          }}
                          className="quill-editor" // Added class for custom styling
                        />

                        {errors.description && (
                          <small className="text-danger">
                            {errors.description}
                          </small>
                        )}
                      </div>

                      <div className="col-md-12 text-center">
                        <button type="submit" className="btn btn-primary">
                          Update Listing
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EditListing;
